import React from 'react'
// @ts-ignore
import { Heatmap } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'
import { Point } from './types'

interface HeatmapProps {
  xCategories: string[]
  yCategories: string[]
  data: Point[]
  valueFormatter?: (point: Point) => string
  chartTitle?: string
  xAxisTooltipLabel?: string
  yAxisTooltipLabel?: string
  dataUnitName?: string
  colorSetting?: string
  rangeMin?: number
  rangeMax?: number
  showDataLabel?: boolean
  opposite?: boolean
  cellType?: 'square' | 'rectangle'
  xAxisStep?: number
  yAxisColorMap?: Record<string, string>
  allowPointSelect?: boolean
  tooltipFormatter?: (point: any) => string
  onSelectChange?: (val: any) => void
  onClick?: (target: any) => void
  enableTooltip?: boolean
}

const HeatmapChart = ({
  xCategories,
  yCategories,
  data,
  valueFormatter,
  chartTitle,
  xAxisTooltipLabel,
  yAxisTooltipLabel,
  dataUnitName,
  colorSetting,
  rangeMin,
  rangeMax,
  showDataLabel,
  opposite,
  cellType,
  xAxisStep,
  yAxisColorMap,
  allowPointSelect,
  tooltipFormatter,
  onSelectChange,
  onClick,
  enableTooltip = true
}: HeatmapProps) => {
  const theme = useDisplayTheme()
  return (
    <Heatmap
      mode={theme}
      xCategories={xCategories}
      yCategories={yCategories}
      data={data}
      valueFormatter={valueFormatter}
      chartTitle={chartTitle}
      xAxisTooltipLabel={xAxisTooltipLabel}
      yAxisTooltipLabel={yAxisTooltipLabel}
      dataUnitName={dataUnitName}
      colorSetting={colorSetting}
      rangeMin={rangeMin}
      rangeMax={rangeMax}
      showDataLabel={showDataLabel}
      opposite={opposite}
      cellType={cellType}
      xAxisStep={xAxisStep}
      yAxisColorMap={yAxisColorMap}
      allowPointSelect={allowPointSelect}
      tooltipFormatter={tooltipFormatter}
      onSelectChange={onSelectChange}
      onClick={onClick}
      enableTooltip={enableTooltip}
    />
  )
}

export default HeatmapChart
